import { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const AuthContext = createContext();

const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_BASE_URL : 'http://localhost:3001';

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [userProfileData, setUserProfileData] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = async () => {
    console.log("calling checkAuth");
    try {
      const response = await axios.get(`${baseURL}/api/getMe`, {
        withCredentials: true,
      });
      
      setUser(response.data.user);
      console.log("check auth ", response.data.user)
    } catch (error) {
      console.error('Error fetching data:', error);
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkAuth();
  }, []);

  const getUserData = async () => {
    try {
      console.log("calling getuserdata")
      const response = await axios.get(`${baseURL}/api/user-profile`, {
        withCredentials: true,
      });
      if (response.data.success) {
        setUserProfileData(response.data);
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  };
  

  return (
    <AuthContext.Provider value={{ user, loading, userProfileData, setUser, checkAuth, getUserData }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
export { AuthContext };